import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a4b2cf28"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "infinite-list",
  style: {"overflow":"auto"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

import { ref, onMounted } from "vue";
import { controlValue } from "@/utils/validate.util.ts";
import { WaterType } from "@/types/waterType.type.ts";
import { useRoute } from "vue-router";
import { postWaterType } from "@/service/waterType.service.ts";
import { ElMessage } from "element-plus";
import { useI18n } from "vue-i18n";

import cloneDeep from "lodash/cloneDeep";


export default /*#__PURE__*/_defineComponent({
  props: {
    list: null
  },
  emits: ["updateWaterType"],
  setup(__props: any, { emit }: { emit: ({
  (e: "updateWaterType", value: WaterType): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  list: WaterType[];
}




const { t } = useI18n();
const route = useRoute();

const newNameWaterType = ref("");

const listWaterType = ref<WaterType[]>([]);

onMounted(() => {
  listWaterType.value = cloneDeep(props.list);
});

const ckeckName = () => {
  const { nuevo, changed } = controlValue(newNameWaterType.value, true, true);
  newNameWaterType.value = nuevo;

  if (changed) {
    ElMessage.warning(t("warning.controlValueInput"));
  }
};
const saveWaterType = async () => {
  const waterType: WaterType = {};
  waterType.name = newNameWaterType.value;
  waterType.samplingPoint = route.query.samplingPoint;
  const newElement = await postWaterType(waterType);
  if (newElement) {
    listWaterType.value.push(newElement);
    emit("updateWaterType", newElement);
    ElMessage.success(t("success.action"));
  }

  newNameWaterType.value = "";
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_input, {
          modelValue: newNameWaterType.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newNameWaterType).value = $event)),
          style: {"width":"240px"},
          placeholder: "Crear un nueva tipología",
          onInput: ckeckName
        }, null, 8, ["modelValue"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: saveWaterType
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("btn.save")), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listWaterType.value, (i) => {
            return (_openBlock(), _createBlock(_component_el_row, {
              key: i,
              class: "infinite-list-item"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(i.name), 1)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ])
      ]),
      _: 1
    }),
    _hoisted_2
  ], 64))
}
}

})